'use strict';

import { breakpoints } from '../settings'

let myMap;

function showMap() {

    var options = {};
    var opt = $.extend({
        mapSelector: '.js-home-map',
        itemSelector: '.js-map-project',
        behaviors: ['multiTouch'],
        controls: [],
        center: ['61.4162342','69.5490719'],
        zoom: 4
    }, options);

    if ($(opt.mapSelector).length == 0) return;

    var placemarks = {};

    var $map = $(opt.mapSelector);
    if (!$map.length) return;

    myMap = new ymaps.Map($map.get(0), {
        behaviors: opt.behaviors,
        center: opt.center,
        zoom: opt.zoom,
        controls: opt.controls
    });

    myMap.behaviors.disable('scrollZoom');
    myMap.controls.add('zoomControl');
    myMap.behaviors.enable('drag'); 

    _init(myMap);
}

function _init(myMap) {
    var items = {};
    $('.js-map-project').each(function(i) {
        var id = $(this).data('object_id');
        var data = $(this).data();
        data.coords = data.coords.split(',');
        items[id] = data;
    });
    //myMap.behaviors.disable('drag');
    var MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
        '<div class="popover">' +
        '<a class="popover__close" href="#">&times;</a>' +
        '<div class="popover__inner">' +
        '$[[options.contentLayout observeSize minWidth=450 maxWidth=500]]' +
        '</div>' +
        '</div>', {
        build: function () {
            this.constructor.superclass.build.call(this);

            this._$element = $('.popover', this.getParentElement());

            this.applyElementOffset();

            this._$element.find('.popover__close')
                .on('click', $.proxy(this.onCloseClick, this));
        },
        clear: function () {
            this._$element.find('.popover__close')
                .off('click');

            this.constructor.superclass.clear.call(this);
        },
        onSublayoutSizeChange: function () {
            MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

            if(!this._isElement(this._$element)) {
                return;
            }

            this.applyElementOffset();

            this.events.fire('shapechange');
        },
        applyElementOffset: function () {
            this._$element.css({
                left: -(this._$element[0].offsetWidth / 2),
                top: -(this._$element[0].offsetHeight)
            });
        },
        onCloseClick: function (e) {
            e.preventDefault();

            this.events.fire('userclose');
        },
        getShape: function () {
            if(!this._isElement(this._$element)) {
                return MyBalloonLayout.superclass.getShape.call(this);
            }
            var position = this._$element.position();
            return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                [position.left, position.top], [
                    position.left + this._$element[0].offsetWidth,
                    position.top + this._$element[0].offsetHeight
                ]
            ]));
        },
        _isElement: function (element) {
            return element && element[0];
        }
    });

    var MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
        '<div class="popover__ballon">'+
        '<div class="popover__image" style="background-image:url($[properties.balloonImage])" ></div>'+
        '<div class="popover__info">'+
        '<a $[properties.balloonHref] class="popover__city">$[properties.balloonCity]</a>'+
        '<a $[properties.balloonHref] class="popover__content">$[properties.balloonContent]</a>'+
        '</div></div>'     
        
    );
    var myCollection = new ymaps.GeoObjectCollection();
    var geoobjects = [];
    for (var j in items) {
        if (items[j].coords.length == 2) {
            if (items[j].href && items[j].href != '##SLINK_ERROR##') {
                console.log(items[j].href);
                items[j].href = 'href=\"'+items[j].href+'\"';
                console.log(items[j].href);
            }
            var myGeoObject = new ymaps.GeoObject({
                    geometry: {
                        type: "Point",
                        coordinates: items[j].coords
                    },
                    properties: {
                        clusterCaption: items[j].city,
                        //content: items[j].info,
                        balloonContent: items[j].info,
                        balloonImage: items[j].pic_src,
                        balloonCity: items[j].city,
                        balloonHref: items[j].href
                    }
                }, {
                    balloonShadow: false,
                    balloonLayout: MyBalloonLayout,
                    balloonContentLayout: MyBalloonContentLayout,
                    balloonPanelMaxMapArea: 0,
                    hideIconOnBalloonOpen: false,
                    iconLayout: 'default#image',
                    iconImageHref: '/i/icons/deactive.svg',
                    iconImageSize: [64, 64],
                    //iconImageOffset: [-30, -30],
            });

            myGeoObject.events
                .add(['mouseenter', 'mouseleave'], function (e) {
                    var target = e.get('target'),
                        type = e.get('type');

                    if (typeof target.getGeoObjects != 'undefined') {
                        // Событие произошло на кластере.
                        if (type == 'mouseenter') {
                            target.options.set('iconLayout', 'default#image');
                            target.options.set('iconImageHref', '/i/icons/hover.svg');
                        } else {
                            target.options.set('iconLayout', 'default#image');
                            target.options.set('iconImageHref', '/i/icons/deactive.svg');
                        }
                    } else if(!myGeoObject.balloon.isOpen()){
                        // Событие произошло на геообъекте.
                        if (type == 'mouseenter') {
                            target.options.set('iconLayout', 'default#image');
                            target.options.set('iconImageHref', '/i/icons/hover.svg');
                        } else {
                            target.options.set('iconLayout', 'default#image');
                            target.options.set('iconImageHref', '/i/icons/deactive.svg');
                        }
                    }
                })
                .add(['balloonclose', 'balloonopen'], function (e) {
                    var target = e.get('target'),
                        type = e.get('type');

                    if (type == 'balloonopen') {
                        target.options.set('iconLayout', 'default#image');
                        target.options.set('iconImageHref', '/i/icons/active.svg');
                    } else {
                        target.options.set('iconLayout', 'default#image');
                        target.options.set('iconImageHref', '/i/icons/deactive.svg');
                    }
                    
                })
            geoobjects.push(myGeoObject);
            myCollection.add(myGeoObject);
            //console.log('Add Geo Object', myGeoObject);
        }
    }
    if (geoobjects.length) {
        // myCollection.add(myGeoObject);
        // myMap.geoObjects.add(myCollection);
        var clusterer = new ymaps.Clusterer({clusterDisableClickZoom: false,             
                        preset: 'islands#invertedVioletClusterIcons',
                        clusterHideIconOnBalloonOpen: false,
                        geoObjectHideIconOnBalloonOpen: false});

        clusterer.options.set({
            gridSize: 128
        });
        clusterer.options.set({
            zoomMargin: 50
        });

        clusterer.add(geoobjects);

        myMap.geoObjects.add(clusterer);

        myMap.setBounds(myMap.geoObjects.getBounds(), {
            checkZoomRange: true,
            zoomMargin: 50
        }).then(function(){ if(myMap.getZoom() > 7) myMap.setZoom(7);});

        balo(clusterer);
    }

    $(window).resize(function(){
        balo(clusterer);
    });
    function balo(myGeoObject) {
        let obj = myGeoObject.getGeoObjects();

        if(window.innerWidth > breakpoints.xxs){

            myGeoObject.options.set({balloonPanelMaxMapArea: 0});
            myGeoObject.options.set({zoomMargin: 50});
            for(let i=0; i< obj.length; i++) {
                obj[i].options.set({balloonPanelMaxMapArea: 0});
            }
            // myGeoObject.options._options.balloonPanelMaxMapArea = 0;
        }
        else{
            myGeoObject.options.set({balloonPanelMaxMapArea: 'Infinity'});
            myGeoObject.options.set({zoomMargin: 25});
            for(let i=0; i< obj.length; i++) {
                obj[i].options.set({balloonPanelMaxMapArea: 'Infinity'});
            }
            // myGeoObject.options._options.balloonPanelMaxMapArea = 'Infinity';
        }
    }
}

export { 
    showMap,
    _init,
    myMap
};